import React, { useRef, useEffect } from 'react';

function OutsideAlerter({ onClick, children }) {
    const wrapperRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            let el = event.target;
            while (el) {
                if (el.classList?.contains('click-outside-disabled')) return;
                el = el.parentElement;
            }
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                onClick();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClick]);

    return <div ref={wrapperRef}>{children}</div>;
}

export default OutsideAlerter;
